export const TOAST_MESSAGE_ERROR_MAP = {
  NO_DOCUMENT_CONTENT: "Cannot update chapter from empty document. Please add some contents to the linked document and try again.",
};
